import React from 'react';
import { useCustomerContext } from '@jbhi-fi/components/src/context/CustomerContextProvider';
import { Portal } from '../../../../components/portal/Portal';
import { useCouponContext } from '../../../../contexts/CouponContextProvider';
import { CartCoupons } from '@jbhi-fi/components/src/Cart/CartCoupons/CartCoupons';
import { useManuallyAppliedCouponContext } from '../../../../contexts/CouponContextProvider/hooks/useManuallyAppliedCouponContext';

export type ShopifyCouponsWrapperProps = {
  containerIdName: string;
};
export const ShopifyCouponsWrapper = ({ containerIdName }: ShopifyCouponsWrapperProps) => {
  const { isPerks, isLoggedIn } = useCustomerContext();
  const {
    isCouponSurfacingEnabled,
    coupons,
    handleSelectCoupon,
    handleRemoveCoupon,
    handleApplyCoupon,
    handleDeselectCoupon,
  } = useCouponContext({
    location: 'cart',
  });

  const { manuallyAppliedCoupons } = useManuallyAppliedCouponContext();

  const shouldShowAvailableCoupons = isCouponSurfacingEnabled && isPerks;
  const container = document.getElementById(containerIdName) as HTMLElement | null | undefined;

  const handleAddCoupon = async (couponCode: string) => {
    await handleApplyCoupon(false, couponCode);
    setTimeout(() => {
      handleDeselectCoupon();
    }, 5000);
  };

  return container ? (
    <Portal container={container}>
      <CartCoupons
        variant="default"
        isLoggedIn={isLoggedIn || false}
        shouldShowAvailableCoupons={shouldShowAvailableCoupons}
        coupons={coupons}
        manuallyAppliedCoupons={manuallyAppliedCoupons}
        handleSelectCoupon={handleSelectCoupon}
        handleRemoveCoupon={handleRemoveCoupon}
        handleAddCoupon={handleAddCoupon}
        handleDeselectCoupon={handleDeselectCoupon}
      />
    </Portal>
  ) : null;
};
